import React from 'react'
import { useLocation } from 'react-router-dom'

import { PageTransition } from './PageTransition'

interface ConditionalTransitionProps {
  children: React.ReactNode
}
export const ConditionalTransition = ({
  children,
}: ConditionalTransitionProps) => {
  const location = useLocation()
  return location.state?.useTransition ? (
    <PageTransition>{children}</PageTransition>
  ) : (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>{children}</>
  )
}
